import React, { useState, useEffect } from 'react';

import { useGetMaxWattage } from 'api/services';
import ChartModal from 'components/ChartModal/ChartModal';
import { chartsKey } from 'utils/constants';

import { getGradientBackground } from './utils/chartColorizing';
import {
	defaultChartAxisValues,
	handleChartData,
	getChartMaxValue,
	increaseOrDecreaseMaxYThreshold,
} from './utils/chartHelpers';
import {
	defaultConfig,
	tooltipCallbackWatts,
	ticksCallbackWatts,
	styledChartElements,
} from './utils/customViewChart';

const MaxWattage = ({ closeChart, isOpen }) => {
	const [data, setData] = useState({});
	const [chartConfig, setChartConfig] = useState(null);
	const [labelsData, setLabelsData] = useState(undefined);

	const { data: maxWattageData, loading } = useGetMaxWattage();
	const isDataAvailable =
		maxWattageData?.data && maxWattageData.data.length > 0;

	useEffect(() => {
		if (isDataAvailable) {
			const dataAdapted = handleChartData(maxWattageData.data);

			setData(dataAdapted);
			setLabelsData(dataAdapted?.labels);
			handleChartConfig();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [maxWattageData]);

	const handleChartConfig = () => {
		const minY = defaultChartAxisValues[chartsKey.maxWattage].minY;
		let maxY = defaultChartAxisValues[chartsKey.maxWattage].maxY;

		const maxValueOfY = getChartMaxValue(maxWattageData.data, 'value');

		if (maxValueOfY && maxValueOfY >= maxY) {
			maxY = maxValueOfY + increaseOrDecreaseMaxYThreshold.xl;
		}

		const config = {
			...defaultConfig,
			plugins: {
				...defaultConfig.plugins,
				tooltip: {
					...defaultConfig.plugins.tooltip,
					callbacks: { label: tooltipCallbackWatts },
				},
			},
			elements: styledChartElements(maxWattageData.data.length - 1),
			scales: {
				...defaultConfig.scales,
				y: {
					...defaultConfig.scales.y,
					min: minY,
					max: maxY,
					ticks: {
						...defaultConfig.scales.y.ticks,
						callback: ticksCallbackWatts,
					},
				},
			},
		};

		setChartConfig(config);
	};

	const getChartData = (canvas) => {
		const gradient = getGradientBackground(canvas);

		return {
			...data,
			datasets: [
				{
					data: data?.datasets[0]?.data,
					fill: true,
					backgroundColor: gradient,
				},
			],
		};
	};

	return (
		<ChartModal
			loading={loading}
			data={getChartData}
			labelsData={labelsData}
			closeChart={closeChart}
			chartConfig={chartConfig}
			isOpen={isOpen}
		/>
	);
};

export default MaxWattage;
